import { render, staticRenderFns } from "./addRiskTaskPage.vue?vue&type=template&id=522e535f&scoped=true&"
import script from "./addRiskTaskPage.vue?vue&type=script&lang=tsx&"
export * from "./addRiskTaskPage.vue?vue&type=script&lang=tsx&"
import style0 from "./addRiskTaskPage.vue?vue&type=style&index=0&id=522e535f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e535f",
  null
  
)

export default component.exports